const WHITE_PAINT_ARTICLE_ERP_ID = "505081";

// The base frame layers are recoloured in the client instead of being served as
// separate assets, so appearance can change without the URLs changing.
export const hasWhiteFilter = (Uterum, src) =>
  (Uterum.PaintArticleErpId === WHITE_PAINT_ARTICLE_ERP_ID ||
    (Uterum.FramePrimed === "YES" && Uterum.FrameColor === "WHITE")) &&
  src.includes("BASE");

export const getPartImages = (Images, assetBaseUrl, Uterum) =>
  Images.map((image) => {
    const src = `${assetBaseUrl}/store/uterumsguide2016/${image.ImageFolder}/${image.ImgAngle}/${image.Area}/${image.Img}.png`;

    return {
      id: `${image.ImageFolder}__${image.ImgAngle}__${image.Area}__${image.Img}`,
      src,
      alt: image.Img,
      whiteFilter: hasWhiteFilter(Uterum, src),
    };
  });

// Describes what is actually rendered, so a genuine visual change can be told
// apart from an update that happens to produce the same result.
export const getRenderKey = (partImages) =>
  partImages
    .map((image) => `${image.src}${image.whiteFilter ? "#w" : ""}`)
    .join("|");
